const doc = [({"all_events":"Minden esemény", "apple_pay":"Apple Pay", "apply":"Alkalmaz", "back":"Vissza", "bank_wire":"Banki átutalás", "code":"Kód", "google_pay":"Google Pay"})];
module.exports = doc.length <= 1 ? doc[0] : doc;